export const CHANNEL_NAMES = {
  CREATE_KOT: "create-kot",
  KOT_REVERSAL: "kot-reversal",
  KOT_PARTIALLY_PROCESSING: "kot-partially-processing",
  KOT_COMPLETE: "kot-complete",
};

export const EVENT_NAMES = {
  CREATE_KOT: "new-kot-created",
};
